(function () {
    'use strict';

    angular
        .module('homeMyTasksControllers')
        .controller('MyTasksInitiativeUpdateStatusAssessmentController', Controller);

    Controller.$inject = ['$scope', '$state', 'businessPlanningService'];

    function Controller($scope, $state, businessPlanningService) {

        var ownerId = $scope.authenticatedUser.ItemPersonID;

        // Get nb tasks        
        businessPlanningService
            .getAssessmentTasks(ownerId)
            .then(function (toSpecify) {
                $scope.tasksCountByName.initiativeUpdateStatusAssess = toSpecify.NbTasks;
            });

        $scope.withTasks = function () {
            return $scope.tasksCountByName.initiativeUpdateStatusAssess > 0;
        };

        // Go To Initiative Update Status to Assess
        $scope.goToInitiativeUpdateStatusToAssess = function () {
            $state.go('initiativeUpdateStatusAssess', { ItemPersonID: ownerId });
        };
    }
})();